import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { FilterType, IFilters } from '@homeviews/models'

export const RES_FEATURE_KEY = 'resource'

// todo
type ResState = {
  filters: IFilters
  activeRes: any
  selections: number[]
}

const initialResState: ResState = {
  filters: {},
  activeRes: null,
  selections: [],
}

export const resSlice = createSlice({
  name: RES_FEATURE_KEY,
  initialState: initialResState,
  reducers: {
    setActiveRes: (
      state,
      { payload: { resource } }: PayloadAction<{ resource?: any }>,
    ) => {
      state.activeRes = resource
    },
    setResFilter: (
      state,
      {
        payload: { filter, value },
      }: PayloadAction<{ filter: FilterType; value: any }>,
    ) => {
      const currentFilters = state.filters
      if (!value) {
        delete currentFilters[filter]
        state.filters = {
          ...currentFilters,
        }
      } else {
        state.filters = {
          ...state.filters,
          [filter]: value,
        }
      }
    },
    setBulkResFilter: (
      state,
      { payload }: PayloadAction<{ filter: FilterType; value: any }[]>,
    ) => {
      let currentFilters = state.filters
      payload.forEach(({ filter, value }) => {
        if (!value) {
          delete currentFilters[filter]
        } else {
          currentFilters = {
            ...currentFilters,
            [filter]: value,
          }
        }
      })
      state.filters = currentFilters
    },
    selectResItem: (state, { payload }) => {
      state.selections = [...state.selections, payload]
    },
    unselectResItem: (state, { payload }) => {
      const newSelections = state.selections.filter((item) => item !== payload)
      state.selections = newSelections
    },
    clearResSelections: (state) => {
      state.selections = []
    },
    clearResFilters: (state) => {
      state.filters = {}
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const resReducer = resSlice.reducer

export const {
  setResFilter,
  setBulkResFilter,
  clearResFilters,
  setActiveRes,
  selectResItem,
  unselectResItem,
  clearResSelections,
} = resSlice.actions

export const getResState = (rootState): ResState => rootState[RES_FEATURE_KEY]

export const selectResFilters = (rootState) =>
  rootState[RES_FEATURE_KEY]?.filters

export const selectActiveRes = (rootState): number =>
  rootState[RES_FEATURE_KEY]?.activeRes
